import { render } from "./TabActividades.vue?vue&type=template&id=0a672d70&scoped=true"
import script from "./TabActividades.vue?vue&type=script&lang=js"
export * from "./TabActividades.vue?vue&type=script&lang=js"

import "./TabActividades.vue?vue&type=style&index=0&id=0a672d70&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a672d70"]])

export default __exports__